import React, { Component } from 'react';
import axios from 'axios'
import * as mat from 'material-ui';
import { browserHistory } from 'react-router';
import * as firebase from 'firebase';

class EmailOption extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: '',
            error: '',
        }
    }
    EmailSender() {
        let userEmail = firebase.auth().currentUser.email;
        let emailObj = {
            email: userEmail,
            message: this.refs.feedback.value,
        }
        if (emailObj.message.length < 15) {
            this.setState({
                error: 'Feedback message is too short.'
            })
        } else {
            // console.log("emailObj", emailObj)
            this.setState({
                error: ''
            })
            axios.post('https://us-central1-mageproject-beadb.cloudfunctions.net/sendEmail', emailObj)
                .then(() => {
                    let message = "Email sent, Thanks for using MAGE"
                    this.setState({ success: message });
                })
                .catch((error) => {
                    let errorMessage = error.message;
                    this.setState({ error: errorMessage });
                })
        }

    }
    cancel() {
        browserHistory.push('/home')
    }
    render() {
        return (
            <div>
                <div >
                    <mat.Card
                        zDepth={0}
                        className='col-md-6 col-md-offset-3 col-xs-10 col-xs-offset-1 login'
                    >
                        <mat.AppBar
                            title='Send your feedback'
                            titleStyle={{ textShadow: '0px 2px 3px gray', fontSize: 30, fontWeight: 'bold', color: '#41c4dd' }}
                            className='text-center'
                            showMenuIconButton={false}
                            style={{ backgroundColor: 'white' }}
                            zDepth={0}
                        />
                        <mat.CardText >
                            <mat.Divider />
                        </mat.CardText >
                        <div className='text-center col-md-12' style={{height: 25}}>
                            {(this.state.success !== '') ? (
                                <p style={{ fontSize: 18, color: 'blue', }}>{this.state.success}</p>
                            ) : (
                                    <span>
                                    </span>
                                )}
                            {(this.state.error !== '') ? (
                                <p style={{ fontSize: 18, color: 'red', }}>{this.state.error}</p>
                            ) : (
                                    <span>
                                    </span>
                                )}
                        </div>
                        <mat.CardText style={{ marginTop: '1%' }}>
                            <div className="form-group">
                                <textarea
                                    placeholder='Share your feedback or request for assistance.'
                                    ref='feedback' className="form-control" rows="5" id="comment"
                                >
                                </textarea>
                            </div>
                        </mat.CardText>
                       
                        <div className='text-right col-md-12'>
                            <mat.RaisedButton
                                onClick={this.cancel.bind(this)}
                                label="Cancel"
                                secondary={true}
                                // labelStyle={{ color: '#ffffff' }}
                                style={{ backgroundColor: '#00bcd4' }}
                            />
                            &nbsp;
                            &nbsp;
                            <mat.RaisedButton
                                onClick={this.EmailSender.bind(this)}
                                label="Send"
                                primary={true}
                                // labelStyle={{ color: '#ffffff' }}
                                style={{ backgroundColor: '#00bcd4' }}
                            />
                        </div>

                    </mat.Card>

                </div>
            </div>
        )
    }
}

export default EmailOption;


// WEBPACK FOOTER //
// ./src/component/email/email.jsx